import { render, staticRenderFns } from "./BannerSlide.vue?vue&type=template&id=5ca1ef83&scoped=true&"
import script from "./BannerSlide.vue?vue&type=script&lang=js&"
export * from "./BannerSlide.vue?vue&type=script&lang=js&"
import style0 from "./BannerSlide.vue?vue&type=style&index=0&id=5ca1ef83&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca1ef83",
  null
  
)

export default component.exports